import { Pie, PieChart as RechartsPieChart } from 'recharts'

type PieChartDataType = {
  key: string
  value: number
  fill: string
}

type PieChartStyleType = {
  size?: {
    width?: number
    height?: number
  }
  margin?: number
  innerRadius?: number
  labelSize?: number
}

interface PieChartProps {
  data: PieChartDataType[]
  isPercentage?: boolean
  style?: PieChartStyleType
}

export const MyPieChart = ({
  data,
  isPercentage,
  style = {}
}: PieChartProps) => {
  const defaultStyle = {
    size: {
      width: 450,
      height: 300
    },
    margin: 20,
    innerRadius: 80,
    labelSize: 24
  }

  const styles = {
    ...defaultStyle,
    ...style,
    size: {
      ...defaultStyle.size,
      ...style.size
    }
  }

  const renderCustomLabel = (props: any) => {
    const radian = Math.PI / 180
    const radius =
      25 + props?.innerRadius + (props?.outerRadius - props?.innerRadius)
    const x = props?.cx + radius * Math.cos(-props?.midAngle * radian)
    const y = props?.cy + radius * Math.sin(-props?.midAngle * radian)

    return (
      <text
        x={x}
        y={y}
        fill={props?.fill}
        textAnchor={x > props?.cx ? 'start' : 'end'}
        dominantBaseline="central"
        fontSize={styles?.labelSize}
        fontWeight={700}
      >
        {props?.value}
        {isPercentage ? '%' : ''}
      </text>
    )
  }
  return (
    <RechartsPieChart
      width={styles?.size?.width}
      height={styles?.size?.height}
      margin={{
        top: styles?.margin,
        bottom: styles?.margin,
        left: styles?.margin,
        right: styles?.margin
      }}
    >
      <Pie
        data={data}
        nameKey="key"
        dataKey="value"
        innerRadius={styles?.innerRadius}
        stroke="none"
        label={renderCustomLabel}
        labelLine={false}
      />
    </RechartsPieChart>
  )
}

export default MyPieChart
